import {
    IConfirmPhoneByEmailProps,
    IConfirmPhoneByEmailResult,
    IConfirmPhoneByFlashCallProps,
    IConfirmPhoneByFlashCallResult,
    IConfirmPhoneByPushProps,
    IConfirmPhoneByPushResult,
    IConfirmPhoneBySmsProps,
    IConfirmPhoneBySmsResult,
    IConfirmPhoneByUserCallProps,
    IConfirmPhoneByUserCallResult,
    IGetConfirmationWaysParams,
    IGetConfirmationWaysResult, IVerifyPhoneByCallProps,
    IVerifyPhoneProps,
    IVerifyPhoneResult
} from "../../../../interface/PhoneConfirmation";
import {axiosInstanceNoToken, axiosInstanceRegisterToken} from "../../../../app/api";

export async function getConfirmationWays({process_id}: IGetConfirmationWaysParams) {
    const params = new URLSearchParams()
    params.append('process_id', process_id.toString())
    return axiosInstanceNoToken.get<IGetConfirmationWaysResult>(`/confirmation/way`, {params}).then(res => res.data)
}

export async function confirmPhoneBySms(data: IConfirmPhoneBySmsProps) {
    return axiosInstanceRegisterToken.post<IConfirmPhoneBySmsResult>(`/sign-up/verify-phone-by`, data).then(res => res.data)
}

export async function confirmPhoneByEmail(data: IConfirmPhoneByEmailProps) {
    return axiosInstanceRegisterToken.post<IConfirmPhoneByEmailResult>(`/sign-up/verify-phone-by`, data).then(res => res.data)
}

export async function confirmPhoneByPush(data: IConfirmPhoneByPushProps) {
    return axiosInstanceRegisterToken.post<IConfirmPhoneByPushResult>(`/sign-up/verify-phone-by`, data).then(res => res.data)
}

export async function confirmPhoneByFlashCall(data: IConfirmPhoneByFlashCallProps) {
    return axiosInstanceRegisterToken.post<IConfirmPhoneByFlashCallResult>(`/sign-up/verify-phone-by`, data).then(res => res.data)
}

export async function confirmPhoneByUserCall(data: IConfirmPhoneByUserCallProps) {
    return axiosInstanceRegisterToken.post<IConfirmPhoneByUserCallResult>(`/sign-up/verify-phone-by`, data).then(res => res.data)
}

export async function verifyPhoneBySms(data: IVerifyPhoneProps) {
    return axiosInstanceRegisterToken.post<IVerifyPhoneResult>(`/confirmation/verify-code-by-sms`, data).then(res => res.data)
}

export async function verifyPhoneByEmail(data: IVerifyPhoneProps) {
    return axiosInstanceRegisterToken.post<IVerifyPhoneResult>(`/confirmation/verify-code-by-email`, data).then(res => res.data)
}

export async function verifyPhoneByPush(data: IVerifyPhoneProps) {
    return axiosInstanceRegisterToken.post<IVerifyPhoneResult>(`/confirmation/verify-code-by-push`, data).then(res => res.data)
}

export async function verifyPhoneByFlashCall(data: IVerifyPhoneProps) {
    return axiosInstanceRegisterToken.post<IVerifyPhoneResult>(`/confirmation/verify-code-by-flashcall`, data).then(res => res.data)
}

export async function verifyPhoneByUserCall(data: IVerifyPhoneByCallProps) {
    return axiosInstanceRegisterToken.post<IVerifyPhoneResult>(`/confirmation/verify-call-back-by-user`, data).then(res => res.data)
}